module.exports = __webpack_public_path__ + "assets/fonts/iconfont.8a2cce0f.eot";